import React, { useContext } from 'react';
import InnerFilterContent, { FilterInnerContentProps } from '../../common/DropdownContent/DynamicFilterInnerContent';
import { Company } from '../../../../../types/company';
import { CompanyContext } from '../../../../../context/CompanyContext';
import { translate } from '../../../../../types/translation/Translator';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';

export default function CompanyFilterInnerContent({
  filter,
  filterProps,
  setFilterProps,
}: FilterInnerContentProps<Company>) {
  const { companies } = useContext(CompanyContext);

  return (
    <InnerFilterContent
      filter={filter}
      filterProps={{ filterProps, setFilterProps }}
      items={[...(filterProps.company || [])]}
      text={id => companies.get(id)?.name || translate({ key: TranslationKey.unknownCompany })}
      onRemove={i => {
        filterProps.company?.delete(i);
        if (!filterProps.company?.size) filterProps.company = undefined;
        setFilterProps({ ...filterProps });
      }}
    />
  );
}
